export const baseApiUrl = 'http://localhost:4000/api/v1';